import { Trash2, History, ExternalLink } from "lucide-react";
import { STATUS_COLORS } from "@agent/lib/styles";

export function DraftRow({ draft, onOpen, onShowVersions, onDelete }) {
  return (
    <div data-testid={`draft-row-${draft.id}`}
      className="bg-white border border-slate-200 rounded-2xl p-5 flex items-center gap-4 shadow-sm hover:shadow-md hover:-translate-y-[1px] transition-all duration-150">
      <div className="flex-1 min-w-0 cursor-pointer" onClick={() => onOpen(draft.id)}>
        <p className="text-sm text-[#0f172a] font-semibold truncate">{draft.title}</p>
        <p className="text-xs text-slate-500 mt-1 truncate">{draft.content?.slice(0, 120)}</p>
        <p className="text-[10px] text-slate-400 mt-1.5">
          {draft.mode === "url" ? `src: ${draft.source?.slice(0, 50)}` : `topic: ${draft.source?.slice(0, 50)}`} · updated {new Date(draft.updated_at).toLocaleString()}
          {draft.linkedin_post_id ? ` · ${draft.linkedin_post_id}` : ""}
        </p>
      </div>
      <span className={`text-[10px] tracking-[0.15em] font-semibold px-3 py-1 rounded-full border uppercase shrink-0 ${STATUS_COLORS[draft.status]}`}>{draft.status}</span>
      <button data-testid={`versions-btn-${draft.id}`} onClick={() => onShowVersions(draft.id)} title="Version history"
        className="text-slate-400 hover:text-indigo-600 transition-colors duration-150 shrink-0"><History size={16} /></button>
      <button data-testid={`open-btn-${draft.id}`} onClick={() => onOpen(draft.id)} title="Open"
        className="text-slate-400 hover:text-[#0f172a] transition-colors duration-150 shrink-0"><ExternalLink size={16} /></button>
      <button data-testid={`delete-btn-${draft.id}`} onClick={() => onDelete(draft.id)} title="Delete"
        className="text-slate-400 hover:text-rose-500 transition-colors duration-150 shrink-0"><Trash2 size={16} /></button>
    </div>
  );
}
